import { useMutation } from 'Data/Api.js'
import mutation from './mutation.graphql.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useDataSubmit, useDataValue } from 'Simple/Data'
import { patientName } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'global',
    viewPath: props.viewPath,
  })
  let appointment_booking = useDataValue({
    context: 'appointment_booking',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ value }) {
    if (!value.chair_id || !value.provider_id || !value.assistant_id) return

    let mutationResponse = await executeMutation({
      id: appointment_booking._id,
      provider_id: value.provider_id,
      assistant_id: value.assistant_id,
      chair_id: value.chair_id,
    })
    if (mutationResponse.error) {
      return notify(
        notifyError(
          `There was a problem seating the patient. Please try again.`
        )
      )
    }
    notify(notifySuccess(`The patient was seated successfully`))
    setFlowTo(normalizePath(props.viewPath, '../No'))
    return submit({
      type: 'tabs/add',
      tab: {
        id: appointment_booking.appointment.patient._id,
        patient_id: appointment_booking.appointment.patient._id,
        name: patientName(appointment_booking.appointment.patient.person),
        type: 'Patient',
        tab: 'treatment_card',
        viewPath: '/App/Account/Content/Patients',
      },
    })
  }
}
